export default function Liveness() {
  //antigamente o liveness era feito aqui, mas mudamos para um projeto separado dentro de https://liveness.grupoaspecir.com.br/
  //para evitar problemas estamos redirecionando aqui, mas podemos apagar essa rota aqui março de 2025.
  window.location.href = window.location.href.replace('gasp.', 'liveness.');
  return '';
}